<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff">
      <div class="flex flex_items flex_center">
        <el-input style="width: 400px;" class="mr20" v-model="keyword" placeholder="请输入证件号/手机号"
          @keyup.enter.native="search"></el-input>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="clear">清空</el-button>
        <el-button type="success" @click="goto('/userList')">会员列表</el-button>
        <el-button type="success" @click="goto('/payCard')">售卡</el-button>
      </div>
      <div>
        <table>
          <tr>
            <td class="tab-bg">姓名</td>
            <td>{{ memberCard.name }}</td>
            <td class="tab-bg">电话</td>
            <td>{{ memberCard.phone }}</td>
          </tr>
          <tr>
            <td class="tab-bg">证件类型</td>
            <td>{{tourist_certificate[memberCard.certificate]}}</td>
            <td class="tab-bg">证件号</td>
            <td>{{ memberCard.code }}</td>
          </tr>
          <tr>
            <td class="tab-bg">开始时间</td>
            <td>{{ memberCard.start_time }}</td>
            <td class="tab-bg">过期时间</td>
            <td>{{ memberCard.end_time }}</td>
          </tr>
        </table>
      </div>


    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      keyword: '',
      memberCard: {
        certificate: '',
        code: '',
        end_time: '',
        id: '',
        name: '',
        other: '',
        phone: '',
        start_time: '',
      },
      tourist_certificate: {}
    };
  },

  methods: {
    goto(url) {
      this.$router.push(url)
    },
    clear() {
      this.keyword = ''
      this.search()
    },
    search() {
      this.api.getUrl('/api/v1/window/yearCard/search', { keyword: this.keyword }).then(res => {
        if (!res.memberCard) {
          this.memberCard = {
            certificate: '',
            code: '',
            end_time: '',
            id: '',
            name: '',
            other: '',
            phone: '',
            start_time: '',
          }
          this.$message.warning('未发现用户')
          return
        }
        this.memberCard = res.memberCard
        this.tourist_certificate = res.tourist_certificate
      })
    }
  },
  created() {
    // this.search()
  },
};
</script>
<style scoped>
table {
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  width: 100%;
  margin-top: 20px;
  border-collapse: collapse;
}

td {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  height: 50px;
  padding: 5px;
}

.tab-bg {
  background: #fafafa;
  width: 10%;
}
</style>
